import API_URLS from '@mgCommon/constants/api-urls.js';
import axiosRestInstance from '@mgCommon/http/axios-rest-client.js';
import { getCbBaseURL, getCbVarible } from '@mgCommon/utils/utils.js';

function restClientInstance() {
  const baseURL = getCbBaseURL();
  return axiosRestInstance({ baseURL });
}

function config(queryParams = {}) {
  const token = getCbVarible();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    params: queryParams,
    data: {},
  };
}

class SmsService {
  sendSms({ smsMessage = '', recipients = [], sender = '' }) {
    const data = {
      smsMessage,
      recipients,
      sender,
    };
    return restClientInstance().post(API_URLS.SEND_SMS, data, config());
  }
}

export default new SmsService();
